/* BarkBurst – cart enhancements, portrait product extras, digital gating */
(function () {
  function enhance() {
    var props = document.querySelectorAll('.cart-items__property:not([data-bb])');
    props.forEach(function (el) {
      el.setAttribute('data-bb', '1');
      var dt = el.querySelector('dt');
      var dd = el.querySelector('dd');
      if (!dt || !dd) return;
      var label = dt.textContent.trim().replace(/:$/, '').toLowerCase();
      if (label === 'foto') {
        var a = dd.querySelector('a');
        if (a && a.href) {
          var img = document.createElement('img');
          img.src = a.href;
          img.alt = 'Dein Foto';
          img.loading = 'lazy';
          a.textContent = '';
          a.appendChild(img);
          a.setAttribute('target', '_blank');
          a.setAttribute('rel', 'noopener');
          a.setAttribute('aria-label', 'Hochgeladenes Foto ansehen');
          el.classList.add('bb-prop-photo');
        }
      }
    });
  }
  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; enhance(); });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-bb-gift]');
    if (!btn || btn.disabled) return;
    btn.disabled = true;
    btn.textContent = '…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(btn.getAttribute('data-bb-gift')), quantity: 1 })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      window.location.reload();
    }).catch(function () {
      btn.disabled = false;
      btn.textContent = 'Nochmal versuchen';
    });
  });

  /* Digital products: only together with a printed product */
  var STYLE_DONE = false;
  function gateDigital() {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!m) return;
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    if (!forms.length) return;
    Promise.all([
      fetch('/products/' + m[1] + '.js').then(function (r) { return r.ok ? r.json() : null; }),
      fetch('/cart.js').then(function (r) { return r.json(); })
    ]).then(function (res) {
      var p = res[0], cart = res[1];
      if (!p) return;
      var tags = (p.tags || []).map(function (t) { return String(t).toLowerCase(); });
      if (tags.indexOf('digital') < 0) return;
      var hasPhysical = cart.items.some(function (i) { return i.requires_shipping; });
      var box = document.createElement('div');
      box.className = 'bb-gate' + (hasPhysical ? ' bb-gate--ok' : '');
      if (hasPhysical) {
        box.innerHTML = '🎁 <strong>Gratis</strong> zu deinem gedruckten Produkt – der Preis wird im Warenkorb automatisch abgezogen.';
      } else {
        box.innerHTML = '🔒 Dieses digitale Extra gibt es <strong>gratis zu jedem Poster oder jeder Tasse</strong>. <a href="/products/portrait-poster">Poster</a> · <a href="/products/portrait-tasse">Tasse</a>';
        forms.forEach(function (f) {
          f.querySelectorAll('button[type="submit"], input[type="submit"]').forEach(function (b) { b.disabled = true; b.setAttribute('aria-disabled', 'true'); b.style.opacity = '.5'; b.style.cursor = 'not-allowed'; });
          f.addEventListener('submit', function (ev) { ev.preventDefault(); ev.stopImmediatePropagation(); }, true);
        });
      }
      if (!STYLE_DONE) {
        STYLE_DONE = true;
        var css = document.createElement('style');
        css.textContent = '.bb-gate{margin:0 0 14px;padding:12px 14px;border:3px solid #1b1530;border-radius:14px;background:#fff3cd;color:#1b1530;font-size:14px;font-weight:600}.bb-gate--ok{background:#d6f7e8}.bb-gate a{color:#1b1530;font-weight:800;text-decoration:underline}';
        document.head.appendChild(css);
      }
      forms[0].parentNode.insertBefore(box, forms[0]);
    }).catch(function () {});
  }

  /* Portrait product page extras */
  function productExtras() {
    var root = document.querySelector('[data-bb-editor]');
    if (!root || root.getAttribute('data-bb-x')) return;
    root.setAttribute('data-bb-x', '1');
    var css = document.createElement('style');
    css.textContent = '.bb-warn{background:#fff3cd;border:2px solid #1b1530;border-radius:12px;padding:10px 12px;font-size:13px;font-weight:700;color:#1b1530;margin-top:10px}' +
      '.bb-x-up{margin-top:16px;border:3px dashed #1b1530;border-radius:16px;padding:14px 16px;background:#fff7ee;color:#1b1530}' +
      '.bb-x-up p{margin:0 0 8px;font-weight:800}.bb-x-up a{display:inline-block;margin:0 8px 6px 0;padding:8px 14px;border:2px solid #1b1530;border-radius:999px;background:#ffd23f;color:#1b1530;font-weight:800;text-decoration:none;font-size:14px}' +
      '.bb-x-up small{display:block;opacity:.75}';
    document.head.appendChild(css);

    var file = root.querySelector('[data-file]');
    var drop = root.querySelector('[data-drop]');
    if (file && drop) {
      var warn = document.createElement('p');
      warn.className = 'bb-warn';
      warn.hidden = true;
      warn.setAttribute('role', 'status');
      drop.parentNode.appendChild(warn);
      file.addEventListener('change', function () {
        warn.hidden = true;
        var f = file.files && file.files[0];
        if (!f || !/^image\/(jpeg|png|webp)$/.test(f.type)) return;
        var url = URL.createObjectURL(f);
        var im = new Image();
        im.onload = function () {
          var mm = Math.min(im.naturalWidth, im.naturalHeight);
          if (mm < 800) {
            warn.textContent = '⚠️ Dein Foto ist ziemlich klein (' + im.naturalWidth + '×' + im.naturalHeight + ' px). Für ein scharfes Portrait wähle bitte, wenn möglich, ein größeres Original.';
            warn.hidden = false;
          }
          URL.revokeObjectURL(url);
        };
        im.src = url;
      });
    }

    var nameInput = root.querySelector('[data-name-input]');
    if (nameInput) {
      var step = nameInput.closest('.bb-pp__step');
      if (step) {
        var wrap = document.createElement('div');
        wrap.className = 'bb-pp__step';
        wrap.innerHTML = '<label class="bb-pp__label" for="bb-bday">Geburtstag deines Hundes <small>(optional)</small></label>' +
          '<input class="bb-input" id="bb-bday" type="text" name="properties[Geburtstag]" maxlength="10" placeholder="TT.MM." autocomplete="off">' +
          '<p class="bb-pp__legal">Wir schicken dir zum Geburtstag eine kleine Überraschung.</p>';
        step.parentNode.insertBefore(wrap, step.nextSibling);
      }
    }

    var form = root.querySelector('form');
    var path = location.pathname;
    var links = [];
    if (/portrait-poster/.test(path)) links = [['Portrait-Tasse', '/products/portrait-tasse']];
    else if (/portrait-tasse/.test(path)) links = [['Portrait-Poster', '/products/portrait-poster']];
    if (form && links.length) {
      var up = document.createElement('div');
      up.className = 'bb-x-up';
      up.innerHTML = '<p>🎁 Als Set noch schöner</p>' + links.map(function (l) { return '<a href="' + l[1] + '">+ ' + l[0] + '</a>'; }).join('') +
        '<small>Ab 2 Produkten −15 % – wird automatisch im Warenkorb abgezogen. Digitale Extras sind bei jedem gedruckten Produkt gratis.</small>';
      form.parentNode.insertBefore(up, form.nextSibling);
    }
  }

  function start() {
    enhance();
    productExtras();
    gateDigital();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();